import React, { FunctionComponent } from 'react';
import SwapIcon from '@mui/icons-material/SwapHoriz';
import { Box, Button } from '@mui/material';

import { showReplaceMaterialsPanel } from '../../../../../store/actions/appActions';
import { useAppDispatch } from '../../../../hooks';

interface Props {
  selectedModelGuid: string;
}

export const MaterialSettingsToolbar: FunctionComponent<Props> = (props) => {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ display: 'flex', m: 1, mt: 2 }}>
      <Button
        sx={{ m: 'auto' }}
        variant="outlined"
        startIcon={<SwapIcon />}
        onClick={() => dispatch(showReplaceMaterialsPanel(props.selectedModelGuid, 'lumbers'))}
      >
        Replace Materials
      </Button>
    </Box>
  );
};
